import VueDOMpurifyHTML from 'vue-dompurify-html';

//eslint-disable-next-line
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueDOMpurifyHTML);
});
